import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    desNo: {
        name: () => '需求确认单编号',
        readOnly: () => true,
    },

    desTitle: {
        name: () => '标题',
    },

    taskNo: {
        name: () => '业务需求单编号',
    },
})
